import { IOrderService } from '../../../../../../../app/entities/OrderService'
import { fetchData } from '../../../../../global/utils/fetch'
import { deleteOrderService } from '../../../../../work-orders/components/work-order-detail/components/tables/line-items/line-items-modal/api'
import { ISchedulerStateProps } from '../container-modal/initialData'
import { ITireSizeError } from './TireSizeQuantity'
import { createOrderService, setOrderServices } from './api'
import { TIRE_SIZE_LIMITS } from '../../../../../global/constants/tire-sizes'
import { DeepPartial } from 'typeorm'
import { ITiresCombination } from '../../../../../../../app/entities/TiresCombination'
import { ITire } from '../../../../../../../app/entities/Tire'
import { Dispatch, SetStateAction } from 'react'

function areTireFieldsValid(
  tire: DeepPartial<ITire> | undefined,
  setTireSizeError: Function,
): boolean {
  let tireFieldsAreValid = true

  if (!tire) {
    //if no tire data then return without setting any errors
    return false
  }

  const { width, diameter, aspectRatio } = tire

  const tireWidthAboveWarningThreshold =
    parseFloat(width ?? '') > TIRE_SIZE_LIMITS.tire_width_warning_min
  const tireWidthAboveDisableThreshold =
    parseFloat(width ?? '') > TIRE_SIZE_LIMITS.tire_width_disable_min

  const tireDiameterIsWithinLimits =
    Number(diameter) >= TIRE_SIZE_LIMITS.tire_diameter_min &&
    Number(diameter) <= TIRE_SIZE_LIMITS.tire_diameter_max

  const tireAspectRatioTooSmall =
    Number(aspectRatio) < TIRE_SIZE_LIMITS.tire_aspect_ratio_lower_min
  const tireAspectRatioInMiddleRange =
    TIRE_SIZE_LIMITS.tire_aspect_ratio_lower_max < Number(aspectRatio) &&
    Number(aspectRatio) < TIRE_SIZE_LIMITS.tire_aspect_ratio_upper_min
  const tireAspectRatioTooLarge =
    Number(aspectRatio) > TIRE_SIZE_LIMITS.tire_aspect_ratio_upper_max

  if (!width) {
    tireFieldsAreValid = false
  } else if (tireWidthAboveWarningThreshold) {
    setTireSizeError((prevState: ITireSizeError) => ({
      ...prevState,
      width: true, //set width error
    }))
    if (tireWidthAboveDisableThreshold) {
      tireFieldsAreValid = false
    }
  } else {
    setTireSizeError((prevState: ITireSizeError) => ({
      ...prevState,
      width: false, //unset width error
    }))
  }

  if (!diameter) {
    tireFieldsAreValid = false
  } else if (!tireDiameterIsWithinLimits) {
    setTireSizeError((prevState: ITireSizeError) => ({
      ...prevState,
      diameter: true, //set diameter error
    }))
    tireFieldsAreValid = false
  } else {
    setTireSizeError((prevState: ITireSizeError) => ({
      ...prevState,
      diameter: false, //unset diameter error
    }))
  }

  if (!aspectRatio) {
    tireFieldsAreValid = false
  } else if (
    tireAspectRatioTooSmall ||
    tireAspectRatioInMiddleRange ||
    tireAspectRatioTooLarge
  ) {
    setTireSizeError((prevState: ITireSizeError) => ({
      ...prevState,
      aspectRatio: true, //set aspect ratio error
    }))
    tireFieldsAreValid = false
  } else {
    setTireSizeError((prevState: ITireSizeError) => ({
      ...prevState,
      aspectRatio: false, //unset aspect ratio error
    }))
  }
  return tireFieldsAreValid
}

export function checkTireFormFields(
  tiresCombintion: DeepPartial<ITiresCombination>,
  setTireSizeError: Function,
): boolean {
  const { frontTire, rearTire } = tiresCombintion

  return (
    areTireFieldsValid(frontTire, setTireSizeError) &&
    areTireFieldsValid(rearTire, setTireSizeError)
  )
}

export const handleCreateAndDeleteOrderService = async (
  createLineItemBody: DeepPartial<IOrderService>,
  id: string,
  schedulerState: ISchedulerStateProps,
  setSchedulerState: Dispatch<SetStateAction<ISchedulerStateProps>>,
) => {
  try {
    const orderServiceResponse = await fetchData<IOrderService>(
      createOrderService(createLineItemBody),
    )
    setSchedulerState((prevState: ISchedulerStateProps) => ({
      ...prevState,
      orderService: orderServiceResponse.objectId,
    }))
    await fetchData<string[]>(
      setOrderServices(
        id,
        schedulerState.orderVehicleId,
        orderServiceResponse.objectId,
      ),
    )
    await fetchData<void>(deleteOrderService(schedulerState.orderService))
  } catch (err) {
    throw new Error()
  }
}
